import { useTranslation } from "react-i18next";
import { Col, Row, Typography } from "antd";
import { useState } from "react";
import "./style.scss";

type Props = {
  isCloseModal: (value: boolean) => void;
  multimediaType: React.Dispatch<React.SetStateAction<string>>;
};

const References = (props: Props) => {
  const { t } = useTranslation();
  const { isCloseModal, multimediaType } = props;

  const handleChooseMultimediaType = (type: string) => {
    isCloseModal(false);
    multimediaType(type)
  };
  const referencesList = [
    {
      title: t("Tài liệu tham khảo", "Tài liệu tham khảo"),
      imgUrl: "/images/PDF.png",
      describe: t("Tải lên và trình bày các tệp PDF trong khóa học ", "Tải lên và trình bày các tệp PDF trong khóa học "),
      type: "reference",
    },
  ];
  return (
    <div className="multimedia">
      {referencesList.map((el, index) => (
        <Col
          key={index}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
          xs={{ span: 24 }}
          onClick={() => handleChooseMultimediaType(el?.type)}
          className="multimedia-item"
        >
          <Row>
            <Col
              md={{ span: 3 }}
              lg={{ span: 3 }}
              xl={{ span: 3 }}
              xs={{ span: 3 }}
            >
              <img src={el.imgUrl} className="multimedia-img" />
            </Col>

            <Col
              md={{ span: 20 }}
              lg={{ span: 20 }}
              xl={{ span: 240 }}
              xs={{ span: 20 }}
            >
              <Typography.Title level={5}>{el.title}</Typography.Title>
              <Typography.Text className="sub-title">
                {el.describe}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
      ))}
    </div>
  );
};

export default References;
